import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||1920}
    height={props.width? `calc( ${props.width}/ 1920 * 151 )`: 151}
    viewBox="0 0 1920 151"
    fill="none"
    style={props.style||{}}
  >
    <path fill="#00C9D6" d="M0 151h108L0 43v108Z" />
    <path
      fill="#fff"
      d="M18.056 136.868h20.411a2.919 2.919 0 0 0 2.916-2.916v-5.831h-2.916v5.831h-20.41v-20.41h20.41v5.831h2.916v-5.831a2.919 2.919 0 0 0-2.916-2.916h-20.41a2.919 2.919 0 0 0-2.916 2.916v20.41a2.92 2.92 0 0 0 2.915 2.916Z"
    />
    <path
      fill="#fff"
      d="m29.723 117.915-7.29 5.832 7.29 5.832v-4.376h11.663v-2.915H29.722v-4.373Z"
    />
    <path
      fill="url(#afg)"
      fillOpacity={0.5}
      d="m110 54 44.5-44H1924v152H110V54Z"
    />
    <path fill="#67FFED" d="M182 25h-8.302L138 61h8.302L182 25Z" />
    <path
      fill="#007D98"
      d="M195.16 56v-6.312l-5.376-11.568h4.56l1.488 3.984c.48 1.344.936 2.592 1.44 3.984h.096c.504-1.392.984-2.64 1.488-3.984l1.488-3.984h4.488l-5.4 11.568V56h-4.272Zm15.363.336c-3.48 0-6.696-2.64-6.696-7.176 0-4.512 3.216-7.152 6.696-7.152 3.456 0 6.672 2.64 6.672 7.152 0 4.536-3.216 7.176-6.672 7.176Zm0-3.456c1.584 0 2.304-1.44 2.304-3.72 0-2.256-.72-3.696-2.304-3.696-1.608 0-2.328 1.44-2.328 3.696 0 2.28.72 3.72 2.328 3.72Zm13.481 3.456c-3 0-4.272-2.136-4.272-5.544v-8.448h4.272v7.92c0 1.872.504 2.424 1.584 2.424.96 0 1.56-.384 2.28-1.392v-8.952h4.272V56h-3.48l-.312-1.872h-.096c-1.128 1.344-2.4 2.208-4.248 2.208ZM235.58 56V42.344h3.48l.312 2.376h.072c1.008-1.824 2.52-2.712 3.888-2.712.816 0 1.272.12 1.656.288l-.696 3.672c-.504-.12-.912-.216-1.512-.216-1.008 0-2.232.648-2.928 2.448V56h-4.272Zm20.409 0V41.696h-4.824V38.12h13.968v3.576h-4.848V56h-4.296Zm13.14.336c-2.52 0-4.056-1.872-4.056-4.152 0-2.88 2.256-4.44 7.584-5.016-.096-1.104-.672-1.752-2.064-1.752-1.08 0-2.208.432-3.576 1.2l-1.488-2.808c1.8-1.08 3.744-1.8 5.88-1.8 3.528 0 5.52 1.968 5.52 6.24V56h-3.48l-.288-1.368h-.12c-1.128 1.008-2.4 1.704-3.912 1.704Zm1.464-3.312c.864 0 1.44-.408 2.064-1.08V49.76c-2.664.336-3.528 1.128-3.528 2.088 0 .792.576 1.176 1.464 1.176Zm15.659 3.312c-3.84 0-6.792-2.64-6.792-7.176 0-4.512 3.36-7.152 7.176-7.152 1.656 0 2.952.576 3.984 1.464l-1.992 2.712c-.624-.504-1.152-.72-1.728-.72-1.896 0-3.072 1.44-3.072 3.696 0 2.28 1.248 3.72 2.904 3.72.864 0 1.68-.408 2.376-.96l1.656 2.808c-1.344 1.176-3.072 1.608-4.512 1.608Zm11.797 0c-3.432 0-4.824-2.184-4.824-5.4V45.68h-1.848v-3.168l2.112-.168.48-3.624h3.528v3.624h3.216v3.336h-3.216v5.208c0 1.512.72 2.112 1.728 2.112.432 0 .912-.144 1.248-.264l.672 3.096c-.72.216-1.704.504-3.096.504Zm5.312-.336V42.344h4.272V56h-4.272Zm2.136-15.552c-1.44 0-2.376-.864-2.376-2.208 0-1.32.936-2.184 2.376-2.184 1.416 0 2.376.864 2.376 2.184 0 1.344-.96 2.208-2.376 2.208Zm11.599 15.888c-3.84 0-6.792-2.64-6.792-7.176 0-4.512 3.36-7.152 7.176-7.152 1.656 0 2.952.576 3.984 1.464l-1.992 2.712c-.624-.504-1.152-.72-1.728-.72-1.896 0-3.072 1.44-3.072 3.696 0 2.28 1.248 3.72 2.904 3.72.864 0 1.68-.408 2.376-.96l1.656 2.808c-1.344 1.176-3.072 1.608-4.512 1.608Zm10.946 0c-1.776 0-3.864-.768-5.256-1.92l1.896-2.664c1.248.936 2.376 1.44 3.456 1.44 1.128 0 1.608-.408 1.608-1.08 0-.816-1.32-1.2-2.712-1.752-1.632-.648-3.48-1.752-3.48-4.032 0-2.568 2.088-4.32 5.28-4.32 2.136 0 3.72.864 4.872 1.752l-1.896 2.544c-.984-.696-1.944-1.152-2.832-1.152-.984 0-1.44.336-1.44.984 0 .816 1.176 1.128 2.592 1.632 1.704.648 3.6 1.632 3.6 4.104 0 2.52-1.968 4.464-5.688 4.464Z"
    />
    <path fill="#fff" d="M1773 10h150v141h-150z" />
    <path fill="#fff" d="M1661 10h-3.2L1531 151h3.2L1661 10Z" opacity={0.5} />
    <path fill="url(#bfg)" d="M1919 10h-202.2L1590 151h202.2L1919 10Z"   onClick={props.next} style={{cursor:'pointer'}} />
    <path onClick={props.next}
      d="M1919 10h-202.2L1590 151h202.2L1919 10Z"
      opacity={0.2}
      style={{
        mixBlendMode: "plus-darker",cursor:'pointer'
      }}
    />
    <g filter="url(#dfg)">
      <path fill="#fff" d="M1717 10h-3.2L1587 151h3.2L1717 10Z" />
    </g>
    <g filter="url(#efg)">
      <path fill="#fff" d="M1788 151h5.2L1920 10h-5.2L1788 151Z" />
    </g>
    <path onClick={props.next} opacity={props.isNext?1:.4}  style={{cursor:'pointer'}}
      fill="#fff"
      d="M1696.37 92V65.18h6.55l6.66 12.852 2.63 5.94h.18c-.33-2.844-.87-6.696-.87-9.9V65.18h6.12V92h-6.55l-6.62-12.924-2.63-5.868h-.18c.29 2.988.83 6.66.83 9.9V92h-6.12Zm38.07.504c-5.9 0-10.44-3.96-10.44-10.764 0-6.624 4.79-10.728 9.72-10.728 5.91 0 8.79 4.284 8.79 9.864 0 1.152-.15 2.268-.29 2.772h-12.03c.58 2.808 2.52 3.96 5.12 3.96 1.47 0 2.84-.432 4.32-1.296l2.12 3.852c-2.12 1.512-4.93 2.34-7.31 2.34Zm-4.35-13.068h6.98c0-2.016-.9-3.528-3.24-3.528-1.76 0-3.31 1.116-3.74 3.528ZM1745.4 92l6.26-10.656-5.9-9.828h6.88l1.69 3.132a98.813 98.813 0 0 0 1.69 3.528h.18c.4-1.152.9-2.34 1.33-3.528l1.26-3.132h6.63l-5.91 10.548 6.27 9.936h-6.88l-1.87-3.24c-.61-1.152-1.23-2.376-1.87-3.492h-.18c-.51 1.116-1.01 2.304-1.52 3.492l-1.4 3.24h-6.66Zm31.95.504c-5.14 0-7.23-3.276-7.23-8.1V76.52h-2.77v-4.752l3.16-.252.72-5.436h5.3v5.436h4.82v5.004h-4.82v7.812c0 2.268 1.08 3.168 2.59 3.168.65 0 1.37-.216 1.87-.396l1.01 4.644c-1.08.324-2.56.756-4.65.756Z"
    />
    <path stroke="#fff" d="m1803 61 17 17-17 17" onClick={props.next} opacity={props.isNext?1:.4}  style={{cursor:'pointer'}} />
    <defs>
      <linearGradient
        id="afg"
        x1={1017}
        x2={1017}
        y1={10}
        y2={162}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.51} stopColor="#E9FFFE" stopOpacity={0.49} />
        <stop offset={1} stopColor="#6AFFF6" />
      </linearGradient>
      <linearGradient
        id="bfg"
        x1={1754.5}
        x2={1754.5}
        y1={10}
        y2={151}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1C1C1" />
        <stop offset={1} stopColor="#67FFED" />
      </linearGradient>
      <filter
        id="dfg"
        width={150}
        height={161}
        x={1573}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-4} />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.94 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_201_2" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_201_2"
          result="shape"
        />
      </filter>
      <filter
        id="efg"
        width={152}
        height={161}
        x={1782}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={4} />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.2375 0 0 0 0 0.86275 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_201_2" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_201_2"
          result="shape"
        />
      </filter>
      <radialGradient
        id="cfg"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(55.729 803.71 1687.314) scale(68.3703 159.531)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6D7CFF" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
    </defs>
  </svg>
)
export default SvgComponent
